var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-checkbox',{attrs:{"label":_vm.labelComputed},on:{"change":_vm.changeTimer},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_vm._v("Auto Refresh")])}
var staticRenderFns = []

export { render, staticRenderFns }